<template>
  <div class="engineer-box">
    <div class="center-container">
      <div class="center-content">
        <div class="img-container">
            <img class="code-img" :src="imgSrc" alt="">
          </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  data () {
    return {
      imgSrc: ''
    }
  },
  created () {
    this.initData()
  },
  methods: {
    initData() {
      let that = this
      this.$api.scanQrcode({
        scan_type: `receive_other`
      }).then(res => {
        if (res.data.msg === true) {
          that.imgSrc = res.data.qrcode_url
          that.sendShow = true
        } else {
          that.$message({
            showClose: true,
            message: '不存在',
            type: 'error',
            customClass: 'msg-position'
          })
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~common/stylus/box.styl'
.img-container
  display: flex;
  justify-content: center;
  padding: 1rem 0;
</style>

